import classes from './StatusTabs.module.css';

export type StatusTabItem<T extends string> = {
  id: T;
  label: string;
  count?: number;
  testId?: string;
};

export function StatusTabs<T extends string>({
  items,
  activeId,
  onChange,
  ariaLabel,
}: {
  items: StatusTabItem<T>[];
  activeId: T;
  onChange: (id: T) => void;
  ariaLabel: string;
}) {
  return (
    <div className={classes.root} role="tablist" aria-label={ariaLabel} data-testid="status-tabs">
      {items.map((item) => {
        const isActive = item.id === activeId;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            data-active={isActive ? 'true' : 'false'}
            className={[classes.tab, isActive ? classes.tabActive : ''].filter(Boolean).join(' ')}
            data-testid={item.testId ?? `status-tab-${item.id}`}
            onClick={() => onChange(item.id)}
          >
            <span>{item.label}</span>
            {item.count !== undefined ? (
              <span className={classes.count}>{item.count}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
